import { render, staticRenderFns } from "./AdminRoles.vue?vue&type=template&id=19d43df8&"
import script from "./AdminRoles.vue?vue&type=script&lang=js&"
export * from "./AdminRoles.vue?vue&type=script&lang=js&"
import style0 from "./AdminRoles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../Monolith/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports